import { FormInstance } from 'antd'
import { useEffect } from 'react'
import { setErrorsToFields } from 'parts/utils/form'
import useLoginFormStore from '../zustand/store'

export enum FieldNames {
	Email = 'email',
	Password = 'password',
}

export type FormValuesType = {
	[FieldNames.Email]: string
	[FieldNames.Password]: string
}

/** Показывает в форме ошибки в случае появления */
export function setErrorsToForm(form: FormInstance) {
	const formErrors = useLoginFormStore((state) => state.formErrors)

	useEffect(() => {
		setErrorsToFields(form, formErrors)
	}, [formErrors])
}
